import { render, staticRenderFns } from "./BookCabins.vue?vue&type=template&id=476d1e8d&"
import script from "./BookCabins.vue?vue&type=script&setup=true&lang=js&"
export * from "./BookCabins.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BookCabins.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports